import { styled } from '@mui/system'

export const Wrapper = styled('div')`
    min-height: 133px;

    .tab-list {
        gap: 10px;
        margin-bottom: 20px;
    }

    .MuiTabs-indicator {
        display: none;
    }

    .Mui-selected {
        font-weight: bold;
    }

    .MuiTabs-root {
        border-bottom: none;
    }

    .MuiButtonBase-root {
        font-size: 1.6rem;
        line-height: 20px;
        display: block;

        :hover {
            cursor: pointer;
        }

        :not(:first-of-type) {
            &:before {
                content: '\\007C';
                margin-right: 8px;
                font-family: var(--font-family-primary);
                font-weight: 100;
                background-color: transparent;
                color: var(--text-color-dark);
            }
        }
    }

    button {
        padding: 0;
    }
`

export const Seperator = styled('div')`
    padding: 0 8px;
`
